import { CustomUser } from '@/models/custom-user.model';

export function formatUserFullname(user: CustomUser): string {
    const displayArray = [];
    let displayName = '';
    if (user) {
        if (user.first_name) {
            displayArray.push(user.first_name);
        }
        if (user.last_name) {
            displayArray.push(user.last_name);
        }
        displayName = displayArray.join(' ');
    } else {
        displayName = '(n.a.)';
    }
    return displayName;
}
